import GoogleMapReact from 'google-map-react';
import '../../../../src/assets/Styles/MapControlDispatchCSS/MapControlDispatch.css'
import React, { useEffect, useState, useRef } from 'react';
import MiniMap from './miniMap';

import { Icon } from '@iconify/react';
import mapIcon from '@iconify-icons/mdi/map-marker-multiple-outline';
import VehicleDispatching from './VehicleDispatch/VehicleDispatching';
import chevronUp from '@iconify-icons/mdi/chevron-up';
import chevronDown from '@iconify-icons/mdi/chevron-down';

import UnroutedMarkerPUIcon from "../../../assets/Images/MapImages/UnRoutedMarker.png"
import UnroutedMarkerDOIcon from "../../../assets/Images/MapImages/UnRoutedMarkerDO.png"
import UnroutedMarkerIcon from "../../../assets/Images/MapImages/UnRoutedMarker.png";
import PUIcon from "../../../assets/Images/MapImages/PUMarker.png";
import CompletedIcon from "../../../assets/Images/MapImages/MarkerCompleted.png";
import SDepot from "../../../assets/Images/MapImages/StartDepotIcon.png";
import EDepot from "../../../assets/Images/MapImages/EndDepotIcon.png";

import LiftOccupied from "../../../assets/Images/MapImages/Lift_OCCUPIED.png";
import CabDisconnected from "../../../assets/Images/MapImages/Cab_Disconnected.png";
import VanOccupied from "../../../assets/Images/MapImages/VAN_OCCUPIED.png";
import SedanOccupied from "../../../assets/Images/MapImages/Sedan_OCCUPIED.png";
import VanOnline from "../../../assets/Images/MapImages/VAN_ONLINE.png";
import SedanOnline from "../../../assets/Images/MapImages/Sedan_Online.png";
import CabOffline from "../../../assets/Images/MapImages/Cab_Offline.png";
import LiftOnline from "../../../assets/Images/MapImages/Lift_ONLINE.png";



import { useSelector } from 'react-redux';
import PersistStorage from '../../../utils/helpers/PersistStorage';
import { Col } from 'react-bootstrap';

import Tags from './Tags';
import MapOverlay from './MapOverlay';
import DateTimeUtils from '../../../utils/DateTimeUtility';
import StatusPanel from './StatusPanel';
import OverlappingMarkerSpiderfier from 'overlapping-marker-spiderfier';
import MapInfoSummary from './MapInfoSummary';
import DispatchAction from '../../Dispatch/DispatchAction';


const MapContainer = (props) => {

    const {
        center,
        onMapReady,
        className,
        showMiniMap,
        showVehicleDispatch, 
        showTripList,
        showTrafficLayer,
        selectedTripFromDispatchQueue,
        vehData,
        deletedTagCallback,
        assignedVehicleToTrip,
        selectedAffiliates,
        options,
        selectedDate,
        height = "100%",
        gridType,
        handleMapHeight,
        routedTripFromDispatchQueue,
        showAllVehiclesOnMap,
        TripType,
        clearMapObjects,
        MapView,
        isZoomLocked,
        currentZoom,
        mapCenterAlign,
        showRouteInfoSection,
        isMapReset,
        DispatchVehicleData,
        DispatchDriverData,
        GridRowData,
        IsDispatchGridDoubleClickSelectionChange,
        sidebarStatus,
        clusterTblStateBeforeCompute,
        SelectedRoute,
        isCalledFromRouteDropDown
    } = props;

    const vehicleMarkerRef = useRef(null);
    const previousLatLngRef = useRef(null);

    const vehicleInfoWindowMap = useRef({});
    const vehicleMarkerMapRef = useRef({});
    const singleVehicleMarkerMapRef = useRef({});
    const userZoomRef = useRef(null);

    const selectedStops = routedTripFromDispatchQueue?.selectedStops || [];
    const clusterGrid = routedTripFromDispatchQueue?.clusterGrid || [];
  
    //const effectiveTripData = selectedStops.length >= 1 ? selectedStops : clusterGrid;
    let effectiveTripData = [];
    let clusterTableTripsToAnimate = [];

    if (selectedStops.length > 1) {
        effectiveTripData = selectedStops;
    } 
    else if (selectedStops.length === 1) {
        const selectedStop = selectedStops[0];
        if(clusterGrid != undefined && Array.isArray(clusterGrid)){
            const matchingStop = clusterGrid.find(
                p => p.TripNo === selectedStop.TripNo && p.Type !== selectedStop.Type
            );
    
            clusterTableTripsToAnimate =  matchingStop ? [selectedStop, matchingStop] : [];
    
            effectiveTripData = clusterGrid;
        }
        
    } else {
        effectiveTripData = clusterGrid;
    }


    const selectedRowTripType = useRef("");
    const [dispatchVehInfo, setDispatchVehInfo] = useState();
    
    const [invokeDispatchComponent, setinvokeDispatchComponent] = useState(false);
    const [dispatchVehicleID, setDispatchVehicleID] = useState(-1);
    const [dispatchDriverID, setDispatchDriverID] = useState(-1);
    
    const [mapReady, setMapReady] = useState(false);
    const CloseVehCount = useRef(0);

    const [infowindows, setinfowindows] = useState([]);
    useEffect(() => {
        return() => {
            //alert("Unmount");
            setVehicleBounds([]);
            setTripBounds([]);
            setRoutedTripBounds([]);
        };

    }, [])

    useEffect(() => {
        if (typeof handleMapHeight === 'function') {
            handleMapHeight(100);
        }
        
    }, [selectedAffiliates, selectedDate])

    const { ASCSSettingData, AffiliateData } = useSelector((store) => store.combinedata); 
    const [affSelected, setAffSelected] = useState(()=> {
        let familySelectionMemory = PersistStorage.retrieve("_SelectedFamilyAffiliates", false);
        if(selectedAffiliates && selectedAffiliates !== ''){
            return selectedAffiliates;
        }
        else {
            return familySelectionMemory;
        }
    });
    const selectedAff = useRef(affSelected);
    const defaultSettings = useRef((selectedAff.current && ASCSSettingData[selectedAff.current] ? JSON.parse(ASCSSettingData[selectedAff.current]): null));
    const startCenterInfo = useRef({ 
        centerLat: (defaultSettings.current ? defaultSettings.current.find((item) => item.SubTitle === "Default-Latitude-To-Focus-On-Zone-Management")?.value : 39.16552683625823), 
        centerLng: (defaultSettings.current ? defaultSettings.current.find((item) => item.SubTitle === "Default-Longitude-To-Focus-On-Zone-Management")?.value : -77.16834351718929)
    });
    const mapCenterRef = useRef({lat:parseFloat(startCenterInfo.current.centerLat), lng:parseFloat(startCenterInfo.current.centerLng)});
    const ITCMapURL = useRef(
        (selectedAff.current && ASCSSettingData[selectedAff.current] ? 
        (JSON.parse(ASCSSettingData[selectedAff.current]).find((item)=>item.SubTitle === "ITCMapServiceURL")).value:"http://itcmap.itcurves.us/api/Map/")
    );
    const OSRM_Username = useRef(
        (selectedAff.current && ASCSSettingData[selectedAff.current] ? 
        (JSON.parse(ASCSSettingData[selectedAff.current]).find((item)=>item.SubTitle === "ITCMapServiceUserName")).value:"annapolis")
    );
    const OSRM_Password = useRef(
        (selectedAff.current && ASCSSettingData[selectedAff.current] ? 
        (JSON.parse(ASCSSettingData[selectedAff.current]).find((item)=>item.SubTitle === "ITCMapServicePassword")).value:"barwoodpass")
    );
    const _selectedDate = useRef(selectedDate);
    const lastUserZoomLevel = useRef((PersistStorage.retrieve("lastUserZoomLevel", false) ? PersistStorage.retrieve("lastUserZoomLevel", false) : null));
    const [zoomOpt, setZoomOpt] = useState({zoomControl: true, draggable: true, scrollWheel: true, disableDoubleClickZoom: false});
    let state = {
        center: mapCenterRef.current ,//{lat:39.16552683625823, lng:-77.16834351718929}, // IT Curves coordinates
        zoom: lastUserZoomLevel.current,
        tilt: 47.5,
        //mapheight: props.options.mapHeight,
        heightoffset: 183,
        mapId: "90f87356969d889c",
        options: {
            gestureHandling: 'greedy',
            zoomControl: zoomOpt.zoomControl,
            draggable: zoomOpt.draggable,
            scrollWheel: zoomOpt.scrollWheel,
            disableDoubleClickZoom: zoomOpt.disableDoubleClickZoom,
        },
        //places: props.MapDetailData,
        commonStyles: {fontFamily: "Roboto,Arial,sans-serif", padding: '0 5px', margin: '10px 0 22px', color: 'rgb(25,25,25)', textAlign: 'center', lineHeight: "38px"}
    };
    
    state = {...state, ...options};

    
    const toggleCollapseVehicleDispatch = () => setIsCollapsedVehicleDispatch(!isCollapsedVehicleDispatch);
    const [markers, setMarkers] = useState([]);
    const [tripMarkers, setTripMarkers] = useState([]);
    const [isCollapsedVehicleDispatch, setIsCollapsedVehicleDispatch] = useState(false);
    const [showMapOverlay, setMapOverlay] = useState(false)
    const [tags, setTags] = useState([]);
    const [isMapLoading, setIsMapLoading] = useState(true); 
    const [vehicleBounds, setVehicleBounds] = useState([]);
    const [singleVehicleBounds, setsingleVehicleBounds] = useState([]);
    const [tripBounds, setTripBounds] = useState([]);
    const [routedTripBounds, setRoutedTripBounds] = useState([]);
    const [routeTripPlotted, setRouteTripPlotted] = useState([]);
    
    const mapBoundsRef = useRef(null);
    const mapRef = useRef(null);
    const mapsRef = useRef(null);
    const trafficLayerRef = useRef(null);

    const doubleClickSelectionChange = useRef(-1);

    useEffect(() => {
        if(effectiveTripData?.length >= 1){
            routeTripPlotted.forEach(p => {
              //  RemoveRoutedTripFromSelection(p.Route);
            });
        }
    }, [routeTripPlotted])

    useEffect(() => {
        if (IsDispatchGridDoubleClickSelectionChange !== doubleClickSelectionChange.current) {
          console.log("🚀 DispatchGridDoubleClick triggered");
    
          // Your logic
          //vehicleMarkerMapRef.current = null;
    
          // Update stored value
          doubleClickSelectionChange.current = IsDispatchGridDoubleClickSelectionChange;
        }
    }, [IsDispatchGridDoubleClickSelectionChange]);


    useEffect(() => {
        debugger
        // if(sidebarStatus == false){
        //     let mapContainer = document.getElementById(options.GridName +'_mapContainer');
        //     if(mapContainer && !state.mapClass.includes("mapOpenStyle")){
             
        //         let mapContainer2 = document.getElementsByClassName("map-wrapper");
        //         if(mapContainer2){
        //             mapContainer2[0].classList.add("map-wrapper-width");
        //         }
        //         else{
             
        //         }
        //     }
        //     else{
        //         let mapContainer2 = document.getElementsByClassName("map-wrapper");
        //         mapContainer2[0].classList.remove("map-wrapper-width");
        //     }
        // }
        // else{
        //     let mapContainer2 = document.getElementsByClassName("map-wrapper");
        //     mapContainer2[0].classList.remove("map-wrapper-width");
        // }

    }, [sidebarStatus])

    useEffect(() => {
       SettingMapBounds();
    }, [vehicleBounds, tripBounds, routedTripBounds, mapCenterAlign]);
    
    const [dispatchingVehicleNo, setDispatchingVehicleNo] = useState(null);
    
    const SettingMapBounds = () => {
        try {
            if (!mapsRef.current || !mapRef.current) return;
        const points = [];
        [...vehicleBounds, ...tripBounds, ...singleVehicleBounds].forEach(pos => {
            try {
                const lat = typeof pos.lat === 'function' ? pos.lat() : pos.lat;
                const lng = typeof pos.lng === 'function' ? pos.lng() : pos.lng;
                if (!isNaN(lat) && !isNaN(lng)) {
                    points.push(new mapsRef.current.LatLng(lat, lng));
                }
            } catch (error) {
                console.warn("Invalid position in vehicle/trip bounds", pos);
            }
        });
    
        routedTripBounds.forEach(item => {
            if (item.position) {
                const lat = typeof item.position.lat === 'function' ? item.position.lat() : item.position.lat;
                const lng = typeof item.position.lng === 'function' ? item.position.lng() : item.position.lng;
                if (!isNaN(lat) && !isNaN(lng)) {
                    points.push(new mapsRef.current.LatLng(lat, lng));
                }
            }
    
            // // Case 2: Polyline
            // if (item.latLngs && typeof item.latLngs.getArray === 'function') {
            //     item.latLngs.getArray().forEach(p => {
            //         const lat = typeof p.lat === 'function' ? p.lat() : p.lat;
            //         const lng = typeof p.lng === 'function' ? p.lng() : p.lng;
            //         if (!isNaN(lat) && !isNaN(lng)) {
            //             points.push(new mapsRef.current.LatLng(lat, lng));
            //         }
            //     });
            // }
        });
    
        // Step 3: Apply to bounds
        if (points.length === 0) return;
    


        const bounds = new mapsRef.current.LatLngBounds();
        points.forEach(pos => bounds.extend(pos));
        


        if (isZoomLocked) {
            const center = bounds.getCenter();
            mapRef.current.setCenter(center);
        } else {
            mapRef.current.fitBounds(bounds);
        }

        if(selectedStops?.length == 1){
           MoveToLastPan();
            
        }
       // mapRef.current.setZoom(userZoomRef.current);

        } catch (error) {
            
        }
    }

    function MoveToLastPan(){
        try {
            if (lastPanRef.current) {
                const { lat, lng, zoom } = lastPanRef.current;
                mapRef.current.setCenter({ lat, lng });
              }    
        } catch (error) {
            
        }
    }


    useEffect(() => {
        if (mapRef.current && trafficLayerRef.current) {
            trafficLayerRef.current.setMap(showTrafficLayer ? mapRef.current : null);
        }
    }, [showTrafficLayer]);

    useEffect(() => {
        const map = mapRef.current;
        if (!map) return;
    
        const newType = MapView
            ? (showTrafficLayer ? 'hybrid' : 'hybrid')
            : 'roadmap';
    
        const currentType = map.getMapTypeId();
        if (currentType !== newType) {
            map.setMapTypeId(newType);
        }
    
        if (trafficLayerRef.current) {
            try {
                trafficLayerRef.current.setMap(showTrafficLayer ? map : null);
            } catch (error) {
                
            }
        }
    }, [MapView, showTrafficLayer]);

    useEffect(() => {
        const map = mapRef.current;
        if (!map) return;
      
        // map.setOptions({
        //   scrollwheel: !isZoomLocked
        // });
      }, [isZoomLocked]);

    
    useEffect(() => {
        ResetMap();
    }, [isMapReset])


    function ResetMap(){
        try {
            handleDeleteAllTags();
            if(tripMarkers?.length > 0){
                tripMarkers.forEach(m => m.setMap(null));
                setTripMarkers([]);
                
            }
            if(markers?.length > 0){
                markers.forEach(marker => {
                    if (marker.isVehicleMarker) {
                    }
                    marker.setMap(null);
                });
            }
            setTags([]);
            setMarkers([]);
            effectiveTripData = [];
            clearVehData();

            setVehicleBounds([]);
            setTripBounds([]);
            setRoutedTripBounds([]);
            vehicleMarkerMapRef.current = {};

        } catch (error) {
            
        }
    }

    function ResetSelectedTripFromDispatchQ(){
        try {
            
            if(tripMarkers?.length > 0){
                tripMarkers.forEach(m => m.setMap(null));
                setTripMarkers([]);
                
            }
            setTags([]);
            if(markers?.length > 0){
                markers.forEach(marker => {
                    if (marker.isVehicleMarker) {
                        marker.setMap(null);
                    }
                });
                setMarkers([]);
            }
            mapBoundsRef.current = null;
            vehicleMarkerMapRef.current = null;
        } catch (error) {
            
        }
    }
    

    useEffect(() => {

        let _SelectedManifestNumber = SelectedRoute;
      
        if (!mapReady || !selectedTripFromDispatchQueue?.length) return;
        if (!mapsRef.current || !mapRef.current) return;

        if (!selectedTripFromDispatchQueue || !Array.isArray(selectedTripFromDispatchQueue)) return;

        

        if (!selectedTripFromDispatchQueue || selectedTripFromDispatchQueue.length === 0) {
            ResetSelectedTripFromDispatchQ();
            return;
        }

        const  allMarkerPositions = [];
           
        const activeRoutes = selectedTripFromDispatchQueue.map(t => t.Route);

       
        tripMarkers.forEach(m => {
            if (!activeRoutes.includes(m.Route)) {
            m.setMap(null);
            }
        });

        if(_SelectedManifestNumber){
            if(selectedTripFromDispatchQueue?.length == 1){
                if(selectedTripFromDispatchQueue[0].vManifestNumber != _SelectedManifestNumber && isCalledFromRouteDropDown == false){
                    return;
                }
            }
        }

      
        const createdMarkers = [];
        const createdTags = [];
        const tempInfoWindows = [];

        const routedTrips = [];

        selectedTripFromDispatchQueue.forEach((trip) => 
        {
          
            const data = trip;
            if (!data) return;

          
        
            const confirmationNo = data.ConfirmationNo;
            const RouteNo = data?.Route || "";

            let isRoutedTrip = false
            if(effectiveTripData?.length > 0){
                effectiveTripData?.forEach(p => {
                    if(p.Route != "" && p.Route == RouteNo){
                        //alert("called");
                        isRoutedTrip = true;
                    }
                });
            }

            if(RouteNo != ""){
                routedTrips.push(data);
            }
        
            if(!isRoutedTrip){
            const pickupPosition = {
                lat: parseFloat(data.PickupLatitude),
                lng: parseFloat(data.PickupLongitude),
            };
        
            const dropPosition = {
                lat: parseFloat(data.DropLatitude),
                lng: parseFloat(data.DropLongitude),
            };
        
            const pickupMarker = new mapsRef.current.Marker({
                position: pickupPosition,
                label: {
                text: "P",
                className: "fw-bold marker_label_css",
                name: confirmationNo
                },
                map: mapRef.current,
                icon: UnroutedMarkerPUIcon,
                ConfirmationNo: confirmationNo,
                Route: RouteNo,
                IsRoutedTrip: false
            });
          
            const position = new mapsRef.current.LatLng(pickupPosition);
            allMarkerPositions.push(position);
            //bounds.extend(position);

            let PUData = transformRoutedTripsData(data);
            const filteredPUData = PUData
            .flatMap(entry => entry.trip)
            .filter(stop => stop.Type === "PU");
            tempInfoWindows.push(new mapsRef.current.InfoWindow({
                content: getInfoWindowString(filteredPUData[0], 'PU'),
            }));

            
     
      
            const dropMarker = new mapsRef.current.Marker({
                position: dropPosition,
                label: {
                text: "D",
                className: "fw-bold marker_label_css",
                name: confirmationNo
                },
                map: mapRef.current,
                icon: UnroutedMarkerDOIcon,
                ConfirmationNo: confirmationNo,
                Route: RouteNo,
                IsRoutedTrip: false
            });

            const DoPosition = new mapsRef.current.LatLng(dropPosition);
            allMarkerPositions.push(DoPosition);
        

            let DOData = transformRoutedTripsData(data);
            const filteredDOData = DOData.flatMap(entry => entry.trip)
            .filter(stop => stop.Type === "DO");
            tempInfoWindows.push(new mapsRef.current.InfoWindow({
                content: getInfoWindowString(filteredDOData[0], 'DO'),
            }));
        

            const line = new mapsRef.current.Polyline({
                path: [pickupPosition, dropPosition],
                geodesic: true,
                strokeColor: "black",
                strokeOpacity: 0.9,
                strokeWeight: 2,
                map: mapRef.current,
                ConfirmationNo: confirmationNo,
                Route: RouteNo,
                IsRoutedTrip: false
            });
        
          
                createdMarkers.push(pickupMarker, dropMarker, line);
                createdTags.push({ ConfirmationNo: confirmationNo, vehiclePlotted: data.PlotVehicle, Route: RouteNo });
            }
        }
        );
    
      
        createdMarkers?.forEach((marker, i) => {
            marker.addListener('mouseover', () => {
                try {
                    tempInfoWindows[i].open(mapRef.current, marker);
                } catch (error) {
                    
                }
            });
            marker.addListener("mouseout", () => {
                try {
                    tempInfoWindows[i].close();
                } catch (error) {
                    
                }
            });
            marker.addListener('click', ()=>{
                try{
                    marker.setAnimation(mapsRef.current.Animation.BOUNCE);
                    stopAnimation(marker);
                }
                catch(error){}
            });
        });

        infowindows.push(...tempInfoWindows);
           
        console.log(tripMarkers);
        setTripMarkers([...tripMarkers, ...createdMarkers]);
        setTags(createdTags);

        if(!isZoomLocked){
            setTripBounds(allMarkerPositions);
        }
      
        if(routedTrips){
            setRouteTripPlotted(routedTrips);
        }

        return () => {
          createdMarkers.forEach(m => m.setMap(null));
        };
      }, [mapReady, selectedTripFromDispatchQueue]);
      


      /// New Implementation for Routed Trips

      const transformRoutedTripsData = (data, removeVehicle = true)=>{
        try{
            
            let transformedData = [];
            let dict = {};
            let Nodes = [];
            let correctFormatData = (Array.isArray(data) && data.length > 0 ? data[0] : (typeof data === 'object' && !Array.isArray(data)) ? data : []);
            if((Array.isArray(data) && data.length === 1) || (typeof data === 'object' && !Array.isArray(data)))
            {
                const isStandardGrid = (state.GridName !== 'standingOrder' && state.GridName !== 'completedQueue');
                const tripNo = (isStandardGrid ? correctFormatData.ConfirmationNo : correctFormatData["Confirmation #"]);
                const PUAddr = (isStandardGrid ? correctFormatData.PickupAddress : correctFormatData["Pick Location"]);
                const DOAddr = (isStandardGrid ? correctFormatData.Destination : correctFormatData["Dest Location"]);
                const timeString = correctFormatData.PickupDateTime.match(/[\sT]+(\d{1,2}:\d{2}\s?[AP]M)/i)?.[1] || '';
                const timePart = timeString.slice(0, -2);
                const meridian = timeString.slice(-2);
                const schTime = (isStandardGrid ? DateTimeUtils.toMilitaryTime(timePart+" "+meridian).military : '');
                Nodes = [
                    {
                        "TripNo": tripNo,
                        "PUPerson": correctFormatData.PickupPerson,
                        "SchTime": schTime,
                        "Type": "PU",
                        "dLatitude": correctFormatData.PickupLatitude,
                        "dLongitude":correctFormatData.PickupLongitude,
                        "vAddress": PUAddr
                    },
                    {
                        "TripNo": tripNo,
                        "PUPerson": correctFormatData.PickupPerson,
                        "SchTime": '',
                        "Type": "DO",
                        "dLatitude": correctFormatData.DropLatitude,
                        "dLongitude":correctFormatData.DropLongitude,
                        "vAddress": DOAddr
                    }
                ];
                dict.trip = Nodes;
                transformedData.push(dict);
            }
            else if(Array.isArray(data) && data.length > 1)
            {
                let trips = [];
                for(let y = 0; y < data.length; y++)
                {
                    dict = {};
                    
                    const timeString = data[y].PickupDateTime.match(/[\sT]+(\d{1,2}:\d{2}\s?[AP]M)/i)?.[1] || '';
                    const timePart = timeString.slice(0, -2);
                    const meridian = timeString.slice(-2);
                    let convertedTime = DateTimeUtils.toMilitaryTime(timePart+" "+meridian);
                    const Nodes = [
                        {
                            "TripNo": data[y].ConfirmationNo,
                            "PUPerson": data[y].PickupPerson,
                            "SchTime": convertedTime.military,
                            "Type": "PU",
                            "dLatitude": data[y].PickupLatitude,
                            "dLongitude":data[y].PickupLongitude,
                            "vAddress": data[y].PickupAddress
                        },
                        {
                            "TripNo": data[y].ConfirmationNo,
                            "PUPerson": data[y].PickupPerson,
                            "SchTime": '',
                            "Type": "DO",
                            "dLatitude": data[y].DropLatitude,
                            "dLongitude":data[y].DropLongitude,
                            "vAddress": data[y].Destination
                        }
                    ];
                    trips.push(Nodes);
                }
                dict.trips = trips;
                transformedData.push(dict);
            }
            return transformedData;
        }
        catch(err){console.log(err); return []}
    };


    function RemoveRoutedTripFromSelection(Route = undefined) {
        try {
            if (selectedTripFromDispatchQueue?.length > 0) {
                for (let i = selectedTripFromDispatchQueue.length - 1; i >= 0; i--) {
                    if (selectedTripFromDispatchQueue[i].Route == Route) {
                        //selectedTripFromDispatchQueue.splice(i, 1);
                    }
                    if (tripMarkers?.length > 0) {
                        tripMarkers.forEach(marker => {
                            if (marker.Route === selectedTripFromDispatchQueue[i].Route) {
                                marker.setMap(null); // Visually removes the marker from the map
                            }
                        });
                    }
                }
            }
        } catch (error) {
            console.error("Error removing routed trips:", error);
        }
    }

    
    useEffect(() => {
        try {
            if (!mapsRef.current || !mapRef.current) return;

            const createdMarkers = [];
            const tempInfowindows = [];
            let routeStops = [];

            const bounds = new mapsRef.current.LatLngBounds();
            const  allMarkerPositions = [];
            
          

        //     const preservedMarkers = tripMarkers.filter(m => m.IsRoutedTrip === false);
        //    // tripMarkers.forEach(marker => marker.setMap(null));
        //    tripMarkers.forEach(marker => {
        //     if (marker.IsRoutedTrip !== false) {
        //       marker.setMap(null); // Remove routed markers only
        //     }
        //   });


        if(selectedStops?.length == 0)
        {
           // debugger
            tripMarkers.forEach(marker => marker.setMap(null));
        }

          const preservedMarkers = tripMarkers.filter(
            m => m.IsRoutedTrip === false && (m.Route === "" || m.Route == null)
          );
          
          // Remove all other markers
          tripMarkers.forEach(marker => {
            if (marker.IsRoutedTrip !== false || (marker.Route !== "" && marker.Route != null)) {
              marker.setMap(null);
            }
          });
        //     const unroutedRoutes = selectedTripFromDispatchQueue
        //     .filter(t => !t.IsRoutedTrip)
        //     .map(t => t.Route);
          
        //   tripMarkers.forEach(m => {
        //       if (!unroutedRoutes.includes(m.Route) && m.Route != "") {
        //           m.setMap(null);
        //       }
        //   });
          

           
            if (!effectiveTripData || effectiveTripData.length === 0) return;
        
          

            if(effectiveTripData?.length > 0){  
                if(selectedStops?.length >= 1){
                    selectedTripFromDispatchQueue.forEach((trip) => 
                    {
                      
                        const data = trip;
                        if (!data) return;
                        const confirmationNo = data.ConfirmationNo;
                        const RouteNo = data?.Route || "";
                        if(RouteNo == ""){
                           // handleTagDelete(data);
                        }
                    });
                }
                //RemoveRoutedTripFromSelection(effectiveTripData[0].Route);              
                effectiveTripData.forEach((stop) => {
                    if (stop.Type === "PU"){

                        const PU  = new mapsRef.current.Marker({
                            position: {
                            lat: parseFloat(stop.dLatitude),
                            lng: parseFloat(stop.dLongitude),
                            },
                            label: {text:("P"+stop.iVehStopOrder), className:"fw-bold marker_label_css", name:stop.TripNo},
                            map: mapRef.current,
                            icon: stop.bPerformed ? CompletedIcon : PUIcon,
                            ConfirmationNo: stop.TripNo,
                            StopType: "PU",
                            IsRoutedTrip: true,
                            Route: stop.Route
                        });
                        routeStops.push({trip:"P", latLng: new mapsRef.current.LatLng(parseFloat(stop.dLatitude),parseFloat(stop.dLongitude)), time: stop.SchTime, ConfirmationNo: stop.TripNo, Route: stop.Route });
                        tempInfowindows.push(new mapsRef.current.InfoWindow({
                            content: getInfoWindowString(stop, 'PU'),
                        }));
                        createdMarkers.push(PU);

                        if (shouldAnimateMarker(stop.TripNo, "PU")) {
                            PU.setAnimation(mapsRef.current.Animation.BOUNCE);
                            stopAnimation(PU); // your existing helper that stops after delay
                            
                        }

                   
                        const position = new mapsRef.current.LatLng(parseFloat(stop.dLatitude), parseFloat(stop.dLongitude));
                        allMarkerPositions.push(position);
                     
                        

                    }
                    else if(stop.Type === "DO"){
                        if(stop.dLatitude !== "" && parseFloat(stop.dLatitude) !== 0){
                            if(stop.bPerformed)
                            {
                                const DO = new mapsRef.current.Marker({
                                    position: {
                                    lat: parseFloat(stop.dLatitude),
                                    lng: parseFloat(stop.dLongitude),
                                    },
                                    label: {text:("D"+stop.iVehStopOrder), className:"fw-bold marker_label_css", name:stop.TripNo},
                                    map: mapRef.current,
                                    icon: CompletedIcon,
                                    ConfirmationNo: stop.TripNo,
                                    StopType: "DO",
                                    IsRoutedTrip: true,
                                    Route: stop.Route
                                });
                                createdMarkers.push(DO);

                                if (shouldAnimateMarker(stop.TripNo, "DO")) {
                                    DO.setAnimation(mapsRef.current.Animation.BOUNCE);
                                    stopAnimation(DO); // your existing helper that stops after delay
                                    
                                }
                              
                                const position = new mapsRef.current.LatLng(parseFloat(stop.dLatitude), parseFloat(stop.dLongitude));
                                allMarkerPositions.push(position);
                              
                            }
                            else
                            {
                                const DO = new mapsRef.current.Marker({
                                    position: {
                                    lat: parseFloat(stop.dLatitude),
                                    lng: parseFloat(stop.dLongitude),
                                    },
                                    label: {text:("D"+stop.iVehStopOrder), className:"fw-bold marker_label_css_DO", name:stop.TripNo},
                                    map: mapRef.current,
                                    ConfirmationNo: stop.TripNo,
                                    StopType: "DO",
                                    IsRoutedTrip: true,
                                    Route: stop.Route
                                });
                                createdMarkers.push(DO);

                                if (shouldAnimateMarker(stop.TripNo, "DO")) {
                                    DO.setAnimation(mapsRef.current.Animation.BOUNCE);
                                    stopAnimation(DO); // your existing helper that stops after delay
                                    
                                }
                                const position = new mapsRef.current.LatLng(parseFloat(stop.dLatitude), parseFloat(stop.dLongitude));
                                allMarkerPositions.push(position);
                              
                            }
                            routeStops.push({trip:"D", latLng: new mapsRef.current.LatLng(parseFloat(stop.dLatitude),parseFloat(stop.dLongitude)), time: stop.SchTime, ConfirmationNo: stop.TripNo, Route: stop.Route });
                            tempInfowindows.push(new mapsRef.current.InfoWindow({
                                content: getInfoWindowString(stop, 'DO'),
                            }));
                        }

                    }
                    else if(stop.Type === "StartDept" || stop.Type === "StartDepot")
                    {
                        const startDept = new mapsRef.current.Marker({
                            position: {
                            lat: parseFloat(stop.dLatitude),
                            lng: parseFloat(stop.dLongitude),
                            },
                            icon:SDepot,
                            map: mapRef.current,
                            ConfirmationNo: stop.TripNo,
                            StopType: "StartDepot",
                            IsRoutedTrip: true,
                            Route: stop.Route
                        });
                        tempInfowindows.push(new mapsRef.current.InfoWindow({
                            content: getInfoWindowString(stop, 'Depot'),
                        }));
                        createdMarkers.push(startDept);
                        const position = new mapsRef.current.LatLng(parseFloat(stop.dLatitude), parseFloat(stop.dLongitude));
                        allMarkerPositions.push(position);
                       
                    }
                    else if(stop.Type === "EndDept" || stop.Type === "EndDepot")
                    {
                        const endDept = new mapsRef.current.Marker({
                            position: {
                            lat: parseFloat(stop.dLatitude),
                            lng: parseFloat(stop.dLongitude),
                            },
                            icon:EDepot,
                            map: mapRef.current,
                            ConfirmationNo: stop.TripNo,
                            StopType: "EndDepot",
                            IsRoutedTrip: true,
                            Route: stop.Route
                        });
                        tempInfowindows.push(new mapsRef.current.InfoWindow({
                            content: getInfoWindowString(stop, 'Depot'),
                        }));
                        createdMarkers.push(endDept);

                     
                        const position = new mapsRef.current.LatLng(parseFloat(stop.dLatitude), parseFloat(stop.dLongitude));
                        allMarkerPositions.push(position);
                    }
                });

                infowindows.push(...tempInfowindows);
                
                let polyPaths = SetPolylinesForRoutedTaxiParaService(routeStops, mapRef.current, mapsRef.current);
                let oms = new OverlappingMarkerSpiderfier( mapRef.current, {
                    markersWontMove: true,
                    markersWontHide: true,
                    spiderfiedShadowColor: false,
                    nudgeStackedMarkers: false,
                });


                createdMarkers?.forEach((marker, i) => {
                    oms.addMarker(marker);
                    marker.addListener('mouseover', () => {
                        try {
                            tempInfowindows[i].open(mapRef.current, marker);
                        } catch (error) {
                            
                        }
                    });
                    marker.addListener("mouseout", () => {
                        try {
                            tempInfowindows[i].close();
                        } catch (error) {
                            
                        }
                    });
                    marker.addListener('click', ()=>{
                        try{
                            marker.setAnimation(mapsRef.current.Animation.BOUNCE);
                            stopAnimation(marker);
                        }
                        catch(error){}
                    });
                });
                
                
                createdMarkers.push(...polyPaths);
                setTripMarkers([...preservedMarkers, ...createdMarkers])
                //setTripMarkers(createdMarkers);
                setRoutedTripBounds(createdMarkers);
                
               
                //PlotUnRoutedTrips();
              

            }
        } catch (error) {
            
        }
    }, [selectedStops, clusterGrid])


    function PlotUnRoutedTrips(){
        try {
        const allMarkerPositions = [];
        const createdMarkers = [];
        const tempInfowindows = [];
        selectedTripFromDispatchQueue.forEach((trip) => 
        {
          
            const data = trip;
            if (!data) return;

          
        
            const confirmationNo = data.ConfirmationNo;
            const RouteNo = data?.Route || "";

            let isRoutedTrip = false
            if(effectiveTripData?.length > 0){
                effectiveTripData?.forEach(p => {
                    if(p.Route != "" && p.Route == RouteNo){
                        //alert("called");
                        isRoutedTrip = true;
                    }
                });
            }

            if(RouteNo != ""){
                //routedTrips.push(data);
            }
            const alreadyPlotted = tripMarkers?.some(m => m.ConfirmationNo === confirmationNo);
        
            if(isRoutedTrip && alreadyPlotted) {return;}

            if(!alreadyPlotted){
            const pickupPosition = {
                lat: parseFloat(data.PickupLatitude),
                lng: parseFloat(data.PickupLongitude),
            };
        
            const dropPosition = {
                lat: parseFloat(data.DropLatitude),
                lng: parseFloat(data.DropLongitude),
            };
        
            const pickupMarker = new mapsRef.current.Marker({
                position: pickupPosition,
                label: {
                text: "P",
                className: "fw-bold marker_label_css",
                name: confirmationNo
                },
                map: mapRef.current,
                icon: UnroutedMarkerPUIcon,
                ConfirmationNo: confirmationNo,
                Route: RouteNo
            });
          
            const position = new mapsRef.current.LatLng(pickupPosition);
            allMarkerPositions.push(position);
            //bounds.extend(position);

            let PUData = transformRoutedTripsData(data);
            const filteredPUData = PUData
            .flatMap(entry => entry.trip)
            .filter(stop => stop.Type === "PU");
            tempInfowindows.push(new mapsRef.current.InfoWindow({
                content: getInfoWindowString(filteredPUData[0], 'PU'),
            }));

            
     
      
            const dropMarker = new mapsRef.current.Marker({
                position: dropPosition,
                label: {
                text: "D",
                className: "fw-bold marker_label_css",
                name: confirmationNo
                },
                map: mapRef.current,
                icon: UnroutedMarkerDOIcon,
                ConfirmationNo: confirmationNo,
                Route: RouteNo
            });

            const DoPosition = new mapsRef.current.LatLng(dropPosition);
            allMarkerPositions.push(DoPosition);
        

            let DOData = transformRoutedTripsData(data);
            const filteredDOData = DOData.flatMap(entry => entry.trip)
            .filter(stop => stop.Type === "DO");
            tempInfowindows.push(new mapsRef.current.InfoWindow({
                content: getInfoWindowString(filteredDOData[0], 'DO'),
            }));
        

            const line = new mapsRef.current.Polyline({
                path: [pickupPosition, dropPosition],
                geodesic: true,
                strokeColor: "black",
                strokeOpacity: 0.9,
                strokeWeight: 2,
                map: mapRef.current,
                ConfirmationNo: confirmationNo,
                Route: RouteNo
            });
        
          
                createdMarkers.push(pickupMarker, dropMarker, line);
                //createdTags.push({ ConfirmationNo: confirmationNo, vehiclePlotted: data.PlotVehicle, Route: RouteNo });
            }
        }
        );
    
      
        createdMarkers?.forEach((marker, i) => {
            marker.addListener('mouseover', () => {
                try {
                    tempInfowindows[i].open(mapRef.current, marker);
                } catch (error) {
                    
                }
            });
            marker.addListener("mouseout", () => {
                try {
                    tempInfowindows[i].close();
                } catch (error) {
                    
                }
            });
            marker.addListener('click', ()=>{
                try{
                    marker.setAnimation(mapsRef.current.Animation.BOUNCE);
                    stopAnimation(marker);
                }
                catch(error){}
            });
        });

        infowindows.push(...tempInfowindows);
           
        console.log(tripMarkers);
        setTripMarkers([...tripMarkers, ...createdMarkers]);

        setTripBounds(allMarkerPositions);
      
        } catch (error) {
            
        }
    }


    const shouldAnimateMarker = (tripNo, stopType) => {
        return clusterTableTripsToAnimate.some(
            item => item.TripNo === tripNo && item.Type === stopType
        );
    };
    
    const SetPolylinesForRoutedTaxiParaService = (routeStopsArray, map, maps) => {
        try {
            let polyPaths = getStraightPolylines(routeStopsArray, map, maps);
            return polyPaths;
        } catch (error) {
            
        }
    }

    const getStraightPolylines = (routeStops, map, maps) =>{
        let temp1DSequence = [];
        let line = null;
        
        let PolyPaths = [];
        for(let i = 0; i < routeStops.length; i++)
        {
            if(routeStops[i]["trip"] === "P")
            {
                temp1DSequence.push(routeStops[i]["trip"]);
            }
            if(i !== (routeStops.length - 1))
            {
                
                if(routeStops[i]["trip"] === "D")
                {
                    if (temp1DSequence.length > 0) {
                        temp1DSequence.shift();
                    }
                    if(temp1DSequence.length === 0)
                    {
                        let lineSymbol = {
                            strokeColor: "purple",
                            path: 'M 0,-1 0,1',
                            strokeOpacity: 0.8,
                            scale: 3
                        };
                        line = new maps.Polyline({
                            path: [routeStops[i]["latLng"], routeStops[i+1]["latLng"]],
                            strokeOpacity: 0,
                            icons: [{
                                icon: lineSymbol,
                                offset: '10px',
                                repeat: '15px'
                            }],
                            strokeWeight: 2,
                            ConfirmationNo: routeStops[i]["ConfirmationNo"],
                            IsRoutedTrip: true,
                            map: map,
                            Route: routeStops[i]["Route"]
                        });
                    }
                    else
                    {
                        line = new maps.Polyline({
                            path: [routeStops[i]["latLng"], routeStops[i+1]["latLng"]],
                            strokeColor: "black",
                            strokeOpacity: 0.9,
                            strokeWeight: 2,
                            ConfirmationNo: routeStops[i]["ConfirmationNo"],
                            IsRoutedTrip: true,
                            map: map,
                            Route: routeStops[i]["Route"]
                        });
                    }
                }
                else
                {
                    line = new maps.Polyline({
                        path: [routeStops[i]["latLng"], routeStops[i+1]["latLng"]],
                        strokeColor: "black",
                        strokeOpacity: 0.9,
                        strokeWeight: 2,
                        ConfirmationNo: routeStops[i]["ConfirmationNo"],
                        IsRoutedTrip: true,
                        map: map,
                        Route: routeStops[i]["Route"]
                    });
                }
                PolyPaths.push(line);
            }
            
        }
        return PolyPaths;
    }

   


    useEffect(() => {
        if (!mapsRef.current || !mapRef.current) return;
        if(vehData?.length == 0 || vehData == undefined){
            vehicleMarkerMapRef.current = null
            markers.forEach(marker => {
                if (marker.isVehicleMarker) {
                }
                marker.setMap(null);
            });
        }
        else if (vehData?.length >= 1 && vehData[0]?.hasOwnProperty("isSingleVehicleCall")) {
            const incomingVehNos = new Set(vehData.map(v => v["iAssignedVehicleId"]));
            markers.forEach(marker => {
              if (marker.isVehicleMarker) {
                if (marker.VehNo && vehicleMarkerMapRef.current?.[marker.VehNo]) {
                  delete vehicleMarkerMapRef.current[marker.VehNo];
                }
          
                if (marker.setMap) marker.setMap(null);
              }
              else if (marker.isSingleVehicleMarker) {
                if (marker.VehNo && !incomingVehNos.has(marker.VehNo)) {
                  if (vehicleMarkerMapRef.current?.[marker.VehNo]) {
                    delete vehicleMarkerMapRef.current[marker.VehNo];
                    if (marker.setMap) marker.setMap(null);
                  }
          
                }
              }
            });
          }
          
          else if (vehData?.length >= 1 && !vehData[0]?.hasOwnProperty("isSingleVehicleCall")) {
            const incomingVehNos = new Set(vehData.map(v => v["VehNo"]));
            markers.forEach(marker => {
              if (marker.isSingleVehicleMarker) {
                if (marker.VehNo && vehicleMarkerMapRef.current?.[marker.VehNo]) {
                  delete vehicleMarkerMapRef.current[marker.VehNo];
                }
          
                if (marker.setMap) marker.setMap(null);
              }
              else if(marker.isVehicleMarker){
                if (marker.VehNo && !incomingVehNos.has(marker.VehNo)) {
                    if (vehicleMarkerMapRef.current?.[marker.VehNo]) {
                      delete vehicleMarkerMapRef.current[marker.VehNo];
                      if (marker.setMap) marker.setMap(null);
                    }
            
                  }
              }
            });
          }
        // else if (vehData?.length >= 1 && vehData[0]?.hasOwnProperty("isSingleVehicleCall")){
        //     markers.forEach(marker => {
        //         if(marker.isVehicleMarker){
        //             marker.setMap(null);
        //         }
        //     })
        // }
        // else if (vehData?.length >= 1 && !vehData[0]?.hasOwnProperty("isSingleVehicleCall")){
        //     markers.forEach(marker => {
        //         if(marker.isSingleVehicleMarker){
        //             marker.setMap(null);
        //         }
        //     })
        // }


        if(!vehData){return;}
        markers.forEach(marker => {
            if (marker.isVehicleMarker) {
                //marker.setMap(null);
            }
        });
    
        const markerMap = singleVehicleMarkerMapRef?.current;
        if (markerMap && typeof markerMap === 'object') {
          Object.values(markerMap).forEach(marker => {
            if (marker && typeof marker.setMap === 'function' && marker.isSingleVehicleMarker == true) {
              //marker.setMap(null);
            }
          });
        
          // Optional: Clear all entries after removal
        }
       //singleVehicleMarkerMapRef.current = {};

        const tempInfoWindowArray = [];
        const allMarkerPositions = [];
        const nonVehicleMarkers = markers.filter(marker => !marker.isVehicleMarker);

        //////////////////// Region: Vehicle Dispatching ////////////////////
        setDispatchVehInfo([]);
        let enableVehDispatchingOptions = true;  
        let vehInfoArr = [];
        CloseVehCount.current = 0;
       
        //////////////////// Region: Vehicle Dispatching ////////////////////

        const newVehicleMarkers = [];
        //const vehicleTrailsRef = {};
        //const vehiclePolylinesRef = {};     
        for(let i = 0; i < vehData?.length; i++)
        {
            if(!vehData[i]?.hasOwnProperty("isSingleVehicleCall")){

                if(vehData[i].STATE !== "OFFLINE" && vehData[i].STATE !== "DISCONNECTED" && parseFloat(vehData[i].Distance) < 20)
                {

                    try {
                        const vehicleId = vehData[i].VehNo;
                        if (!vehicleMarkerMapRef.current) {
                            vehicleMarkerMapRef.current = {};
                        }

                        const direction = parseFloat(vehData[i].DIRECTION) || 0;
                        const newPosition = new mapsRef.current.LatLng(parseFloat(vehData[i].LATITUDE), parseFloat(vehData[i].LONGITUDE));
                        if (vehicleMarkerMapRef.current[vehicleId]) 
                        {
                            // Vehicle marker already exists → animate it
                            const marker = vehicleMarkerMapRef.current[vehicleId];
                            const originalIconUrl = getVehicleImage2(vehData[i]); 

                            const oldPosition = marker.getPosition();
            
                            const moved =
                                oldPosition.lat().toFixed(6) !== newPosition.lat().toFixed(6) ||
                                oldPosition.lng().toFixed(6) !== newPosition.lng().toFixed(6);

                            
                            if(moved){
                                animateMarker(marker.getPosition(), newPosition, marker, vehicleId, mapRef.current);
                                createRotatedIcon(originalIconUrl, direction).then(rotatedIconUrl => {
                                    marker.setIcon({
                                        url: rotatedIconUrl,
                                        scaledSize: new mapsRef.current.Size(24, 24),
                                        anchor: new mapsRef.current.Point(16, 16),
                                    });
                                });
                            }
                            newVehicleMarkers.push(marker); 
                            const _infowindows = new mapsRef.current.InfoWindow({
                                content: getInfoWindowString(vehData[i], 'vehicle'),
                            });
                            tempInfoWindowArray.push(_infowindows);
                            
                            if(enableVehDispatchingOptions){
                                let vehDict = {};
                                CloseVehCount.current += 1;
                                vehDict["vehNo"] = vehData[i].VehNo;
                                vehDict["Dist"] = vehData[i].Distance;
                                vehDict["MapVehicleID"] = vehData[i].iVehicleID;
                                vehDict["MapDriverID"] = vehData[i].iDriverID;
                                vehInfoArr.push(vehDict);
                            }

                            
                        } 
                        else 
                        {
                            let vehicleImg = getVehicleImage2(vehData[i]);
                            let marker = CreateVehicleMarker(mapRef.current, mapsRef.current, vehData[i].LATITUDE, vehData[i].LONGITUDE, 'dispatched_Vehicle', vehicleImg, vehData[i].DIRECTION);
                            marker.isVehicleMarker = true;
                            marker.VehNo = vehData[i].VehNo;
                            marker.ConfirmationNo= selectedTripFromDispatchQueue[0].ConfirmationNo
                            newVehicleMarkers.push(marker); 
                            const _infowindows = new mapsRef.current.InfoWindow({
                                content: getInfoWindowString(vehData[i], 'vehicle'),
                            });
                            tempInfoWindowArray.push(_infowindows);
                            
                            if(enableVehDispatchingOptions){
                                let vehDict = {};
                                CloseVehCount.current += 1;
                                vehDict["vehNo"] = vehData[i].VehNo;
                                vehDict["Dist"] = vehData[i].Distance;
                                vehDict["MapVehicleID"] = vehData[i].iVehicleID;
                                vehDict["MapDriverID"] = vehData[i].iDriverID;
                                vehInfoArr.push(vehDict);
                            }
                            vehicleMarkerMapRef.current[vehicleId] = marker;
                        }


                        const position = new mapsRef.current.LatLng(parseFloat(vehData[i].LATITUDE), parseFloat(vehData[i].LONGITUDE));
                        allMarkerPositions.push(position);

                    } catch (error) {
                        
                    }
                }
            }
            else if(vehData[i]?.hasOwnProperty("isSingleVehicleCall")){
                if (vehData?.[i]?.hasOwnProperty("ServiceStatus")) 
                {
                    const vehicle = vehData[0];
                    const serviceStatus = vehicle?.ServiceStatus?.toUpperCase();
                    const driverLat = vehicle?.DriverLocationLatitude;
                    const driverLng = vehicle?.DriverLocationLongitude;
                    const direction = parseFloat(vehicle.DIRECTION) || 0;
                    let confirmationNo = "";
                    if(vehicle["Confirmation #"] != undefined){
                        confirmationNo = vehicle["Confirmation #"];
                    }
                    
    
                    const dispatchedStatuses = new Set(["IRTPU", "DISPATCHED", "ACCEPTED", "ASSIGNED"]);
    
                    const isDriverLocationValid = driverLat != null && driverLng != null;
    
                    const shouldShowMarker = dispatchedStatuses.has(serviceStatus) ||
                     parseFloat(vehicle?.EstimatedDistance) < 20;
    
    
                    if (shouldShowMarker && isDriverLocationValid) {
                        
                        if (!vehicleMarkerMapRef.current) {
                            vehicleMarkerMapRef.current = {};
                        }
                        const vehicleId = vehicle.iAssignedVehicleId;
                        const newPosition = new mapsRef.current.LatLng(parseFloat(driverLat), parseFloat(driverLng));
    
                        if (vehicleMarkerMapRef.current[vehicleId]) 
                        {
                            const marker = vehicleMarkerMapRef.current[vehicleId];
                            const originalIconUrl = getVehicleImage2(vehData); 
    
                            const oldPosition = marker.getPosition();
                            const moved =
                            oldPosition.lat().toFixed(6) !== newPosition.lat().toFixed(6) ||
                            oldPosition.lng().toFixed(6) !== newPosition.lng().toFixed(6);
                            if(moved){
                                animateMarker(marker.getPosition(), newPosition, marker, vehicleId, mapRef.current);
                                createRotatedIcon(originalIconUrl, direction).then(rotatedIconUrl => {
                                    marker.setIcon({
                                        url: rotatedIconUrl,
                                        scaledSize: new mapsRef.current.Size(24, 24),
                                        anchor: new mapsRef.current.Point(16, 16),
                                    });
                                });
                            }
                            if (vehicleInfoWindowMap.current[vehicleId]) {
                                vehicleInfoWindowMap.current[vehicleId].close();
                                delete vehicleInfoWindowMap.current[vehicleId];
                            }
                            const newInfoWindow = new mapsRef.current.InfoWindow({
                                content: getInfoWindowString(vehicle, 'vehicle', true),
                            });
                            tempInfoWindowArray.push(newInfoWindow);
                            vehicleInfoWindowMap.current[vehicleId] = newInfoWindow;
                            //markers.push(marker);
                            //setMarkers(markers);
                            newVehicleMarkers.push(marker);
                            allMarkerPositions.push(newPosition);
                        }
                        else
                        {
                            let vehicleImg = getVehicleImage2(vehData);
                            const createdVehMarker = CreateVehicleMarker(mapRef.current, mapsRef.current, driverLat, driverLng, 'dispatched_Vehicle', vehicleImg);
                            if (createdVehMarker) {
                                createdVehMarker.isSingleVehicleMarker = true;
                                createdVehMarker.ConfirmationNo = confirmationNo;
                                createdVehMarker.VehNo = vehicleId;
                                //markers.push(createdVehMarker);
                                //setMarkers(markers);
                                newVehicleMarkers.push(createdVehMarker);
                            }
                            const _infowindows = new mapsRef.current.InfoWindow({
                                content: getInfoWindowString(vehicle, 'vehicle', true),
                            });
                            tempInfoWindowArray.push(_infowindows);
                            vehicleInfoWindowMap.current[vehicleId] = _infowindows;
                            // infowindows.push(new mapsRef.current.InfoWindow({
                            //     content: getInfoWindowString(vehicle, 'vehicle', true),
                            // }));
                            // const lastInfoWindow = infowindows[infowindows.length - 1];
    
                            // if (markers && lastInfoWindow) {
                            //     markers[0].addListener("mouseover", () => {
                            //         lastInfoWindow.open(mapRef.current, markers[0]);
                            // });
                            
                            // markers[0].addListener("mouseout", () => {
                            //     lastInfoWindow.close();
                            // });
                            // }
                            const vehPosition = {
                                lat: parseFloat(driverLat),
                                lng: parseFloat(driverLng),
                            };
                            const vehiclePosition = new mapsRef.current.LatLng(vehPosition);
                            //vehicleMarkerPosition.push(vehiclePosition);
                            allMarkerPositions.push(vehiclePosition);
                            //setsingleVehicleBounds(vehicleMarkerPosition);
                            vehicleMarkerMapRef.current[vehicleId] = createdVehMarker;
                        }
                    }
                } 
            }
        }

        newVehicleMarkers?.forEach((marker, i) => {
            marker.addListener('mouseover', () => {
                if(tempInfoWindowArray?.length > 0){
                    tempInfoWindowArray[i].open(mapRef.current, marker);
                }
            });
            marker.addListener("mouseout", () => {
                if(tempInfoWindowArray?.length > 0){
                    tempInfoWindowArray[i].close();
                }
            });
            marker.addListener('click', ()=>{
                try{
                    marker.setAnimation(mapsRef.current.Animation.BOUNCE);
                    stopAnimation(marker);
                }
                catch(error){}
            });
        });
        setMarkers([...nonVehicleMarkers, ...newVehicleMarkers]);

        if(enableVehDispatchingOptions){
            setDispatchVehInfo(prev => [...prev, vehInfoArr]);
        }
        if(!isZoomLocked){
            setVehicleBounds(allMarkerPositions);
        }

    }, [vehData])




    const getInfoWindowString = (place, type, single_vehicle = false) => {
        
        let common_info = "";
        let labelMap = {
            PU: 'Scheduled Pickup',
            DO: 'Scheduled Dropoff',
            Depot: 'Vehicle Info'
        };
        let isDepot = (type === 'Depot');
        let title = isDepot? 'Depot Name' : 'Rider';
        let schTimeVal = isDepot ? place.VehicleInfo : place.SchTime;
        if (type in labelMap) {
            common_info += `
              <div>
                <div class="text-start">
                  <b class="fw-bold">${title}:</b> ${place.PUPerson} <br>
                  <b class="fw-bold">Address:</b> ${place.vAddress} <br>
                  <b class="fw-bold">${labelMap[type]}:</b> ${schTimeVal}
                </div>
              </div>`;
        }
        else {
            if (single_vehicle) {
                let MsgPUorDO = "";
                if (place.hasOwnProperty("TripRequestStatus")) {
                    if(place.TripRequestStatus == "PICKEDUP"){
                        MsgPUorDO = "Customer picked up, DropOff ETA is not available at the moment.";
                        const EstTimeOD = place?.DOETA || "";
                        const MilesPUorDO = place?.MilesPickOrDrop || "";
                        
                        if (EstTimeOD.trim() !== "") {
                            MsgPUorDO = `Customer picked up & will be dropped at ${EstTimeOD} (${MilesPUorDO} Miles)`;
                        }
                    }
                    else if(place.TripRequestStatus == "ATLOCATION"){
                        MsgPUorDO = "At customer location, DropOff ETA is not available at the moment.";
                        const EstTimeOD = place?.DOETA || "";
                        const MilesPUorDO = place?.MilesPickOrDrop || "";
                        if (EstTimeOD.trim() !== "") {
                            MsgPUorDO = "At customer location & customer will be dropped at " + EstTimeOD + " ( " + MilesPUorDO + " Miles )";
                        }
                    }
                    else if(place.TripRequestStatus == "IRTPU"){
                        MsgPUorDO = "ETA is not available at the moment.";
                        const EstTime = place?.PUETA || "";
                        const MilesPUorDO = place?.MilesPickOrDrop || "";
                        
                        if (EstTime.trim() !== "") {
                            MsgPUorDO = `Driver will reach pickup location at ${EstTime} (${MilesPUorDO} Miles)`;
                        }
                    }

                    common_info += `
                        <div>
                            <div class="text-start">
                                <b class="fw-bold float-left">Vehicle #: </b>
                                    ${place['VEH#']} 
                                <b class="fw-bold float-right" >Driver #:
                                    <b class="fw-light">
                                        ${place['AssignedDriver#']}
                                    </b>
                                </b><br>
                                <b class="fw-bold">State:</b> 
                                    ${(!place.TripRequestStatus ? "N/A" : place.TripRequestStatus)} <br>
                                <b class="fw-bold">VehicleInfo:</b> 
                                    ${(!place.VTYPE? "" : place.VTYPE + " ") + place.VehicleInfo} <br>
                                    <b class="fw-bold">ETA: </b> ${MsgPUorDO} 
                                <!-- <b class="fw-bold">ETA:</b> ${"(" + place.EstimatedDistance + " Miles)"} <br> -->
                            </div>
                        </div>`
                    ;
                } else {
                    common_info += `
                        <div>
                            <div class="text-start">
                            <b class="fw-bold float-left">Vehicle #: </b>
                                ${place.VehNo} 
                            <b class="fw-bold float-right">Driver #:
                                <b class="fw-light">
                                    ${place.DriverNo}
                                </b>
                            </b><br>
                            <b class="fw-bold">State:</b> ${place.STATE} <br>
                            <b class="fw-bold">VehicleInfo:</b> ${place.VehMake + "("+place.VehicleMake+")"} <br>
                            <b class="fw-bold">ETA:</b> ${"("+place.Distance +" Miles)"} <br>
                            </div>
                        </div>`
                    ;
                }

            }
            else {
                // let driver_no = place.AssignedDriver;
                common_info += `
                <div>
                  <div class="text-start">
                    <b class="fw-bold float-left">Vehicle #: </b>
                        ${place.VehNo} 
                    <b class="fw-bold float-right" >Driver #:
                        <b class="fw-light">
                            ${place.DriverNo}
                        </b>
                    </b><br>
                    <b class="fw-bold">State:</b> ${place.STATE} <br>
                    <b class="fw-bold">VehicleInfo:</b> ${place.VehMake + "("+place.VehicleMake+")"} <br>
                    <b class="fw-bold">ETA:</b> ${"("+place.Distance +" Miles)"} <br>
                  </div>
                </div>`;
            };
        }
        return common_info;
    }

    useEffect(() => {
        console.log("Plotting single assigned vehicle to trip");
        //alert("Plotting single vehicle on map");
        PlotSingleVehicleOnMap(assignedVehicleToTrip, mapRef.current, mapsRef.current);

    }, [assignedVehicleToTrip])

    const PlotSingleVehicleOnMap = (tripData, map, maps) => 
    {
        try 
        {
            if(tripData?.length == 0 ){
                singleVehicleMarkerMapRef.current = {};
            }
            let markers = [];
            
            const bounds = new maps.LatLngBounds();
            const vehicleMarkerPosition = [];
            
            const markerMap = vehicleMarkerMapRef?.current;
            if (markerMap && typeof markerMap === 'object') {
              Object.values(markerMap).forEach(marker => {
                if (marker && typeof marker.setMap === 'function') {
                  //marker.setMap(null);
                }
              });
            
              // Optional: Clear all entries after removal
              //vehicleMarkerMapRef.current = {};
            }

            if (tripData?.[0]?.hasOwnProperty("ServiceStatus")) 
            {
                const vehicle = tripData[0];
                const serviceStatus = vehicle?.ServiceStatus?.toUpperCase();
                const driverLat = vehicle?.DriverLocationLatitude;
                const driverLng = vehicle?.DriverLocationLongitude;
                 const direction = parseFloat(vehicle.DIRECTION) || 0;
                let confirmationNo = "";
                if(vehicle["Confirmation #"] != undefined){
                    confirmationNo = vehicle["Confirmation #"];
                }
                

                const dispatchedStatuses = new Set(["IRTPU", "DISPATCHED", "ACCEPTED", "ASSIGNED"]);

                const isDriverLocationValid = driverLat != null && driverLng != null;

                const newPosition = new mapsRef.current.LatLng(parseFloat(driverLat), parseFloat(driverLng));
                const shouldShowMarker = dispatchedStatuses.has(serviceStatus) ||
                 parseFloat(vehicle?.EstimatedDistance) < 20;

                //Clear other vehicle markers when single is plotting
                //vehicleMarkerMapRef.current = {};

                if (shouldShowMarker && isDriverLocationValid) {
                    
                    if (!singleVehicleMarkerMapRef.current) {
                        singleVehicleMarkerMapRef.current = {};
                    }
                    const vehicleId = vehicle.iAssignedVehicleId;
                    const newPosition = new maps.LatLng(parseFloat(driverLat), parseFloat(driverLng));

                    if (singleVehicleMarkerMapRef.current[vehicleId]) 
                    {
                        const marker = singleVehicleMarkerMapRef.current[vehicleId];
                        const originalIconUrl = getVehicleImage2(tripData); 

                        const oldPosition = marker.getPosition();
                        const moved =
                        oldPosition.lat().toFixed(6) !== newPosition.lat().toFixed(6) ||
                        oldPosition.lng().toFixed(6) !== newPosition.lng().toFixed(6);
                        if(moved){
                            animateMarker(marker.getPosition(), newPosition, marker, vehicleId, map);
                            createRotatedIcon(originalIconUrl, direction).then(rotatedIconUrl => {
                                marker.setIcon({
                                    url: rotatedIconUrl,
                                    scaledSize: new mapsRef.current.Size(24, 24),
                                    anchor: new mapsRef.current.Point(16, 16),
                                });
                            });
                        }
                        markers.push(marker);
                        setMarkers(markers);
                    }
                    else
                    {
                        let vehicleImg = getVehicleImage2(tripData);
                        const createdVehMarker = CreateVehicleMarker(map, maps, driverLat, driverLng, 'dispatched_Vehicle', vehicleImg);
                        if (createdVehMarker) {
                            createdVehMarker.isSingleVehicleMarker = true;
                            createdVehMarker.ConfirmationNo = confirmationNo;
                            
                            markers.push(createdVehMarker);
                            setMarkers(markers);
                        }
                        infowindows.push(new maps.InfoWindow({
                            content: getInfoWindowString(vehicle, 'vehicle', true),
                        }));
                        const lastInfoWindow = infowindows[infowindows.length - 1];

                        if (markers && lastInfoWindow) {
                            markers[0].addListener("mouseover", () => {
                                lastInfoWindow.open(mapRef.current, markers[0]);
                        });
                        
                        markers[0].addListener("mouseout", () => {
                            lastInfoWindow.close();
                        });
                        }
                        const vehPosition = {
                            lat: parseFloat(driverLat),
                            lng: parseFloat(driverLng),
                        };
                        const vehiclePosition = new mapsRef.current.LatLng(vehPosition);
                        vehicleMarkerPosition.push(vehiclePosition);
                        setsingleVehicleBounds(vehicleMarkerPosition);
                        singleVehicleMarkerMapRef.current[vehicleId] = createdVehMarker;
                    }
                }
            } 
        } 
        catch (error) 
        {  
        }
    }


    
    const vehiclePosition = { lat: 12.9716, lng: 77.5946 };
    const createMapOptions = (maps) => {
        
        return {
          zoomControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
          streetViewControl: true,
          scrollwheel: true,//!isZoomLocked,
          disableDoubleClickZoom: isZoomLocked
        };
      };


    let lastInteractionWasWheel = false;
    let wheelTimeout = null;
    const lastPanRef = useRef();
    
    //const defaultZoom = 8;
    const handleApiLoaded = ({ map, maps }) => {
        if (!map) return;
        onMapReady?.(map, maps);
        mapRef.current = map;
        mapsRef.current = maps;
        trafficLayerRef.current = new maps.TrafficLayer();
        if (showTrafficLayer) {
            try {
                trafficLayerRef.current.setMap(map);
            } catch (error) {
                
            }
        }

        if (!isZoomLocked) {
            //alert("called");
            //map.setZoom(userZoomRef.current);
        }
        
          // Enforce zoom lock options after map has loaded
        // map.setOptions({
        //     scrollwheel: !isZoomLocked,
        //     disableDoubleClickZoom: isZoomLocked
        // });
        setMapReady(true);

        const initialPosition = new maps.LatLng(center);
        previousLatLngRef.current = initialPosition;
        let mouseWheelZoom = false;

        map.addListener("wheel", () => {
            mouseWheelZoom = true;
        });

        map.addListener("zoom_changed", () => {
            if (lastInteractionWasWheel) {
                userZoomRef.current = map.getZoom();
              }
              const center = map.getCenter();
              lastPanRef.current = {
                lat: center.lat(),
                lng: center.lng(),
                zoom: map.getZoom()
              };
          });

        setTimeout(() => {
            setIsMapLoading(false);
        }, 2000);

        setTimeout(() => {
            const mapContainer = document.querySelector('.gm-style'); // main map container
            if (mapContainer) {
              mapContainer.addEventListener('wheel', () => {
                lastInteractionWasWheel = true;
          
                clearTimeout(wheelTimeout);
                wheelTimeout = setTimeout(() => {
                  lastInteractionWasWheel = false;
                }, 500); // Reset after 500ms of inactivity
              });
            }
          }, 500);

        // if(sidebarStatus == true){
        //     let mapContainer = document.getElementById(options.GridName +'_mapContainer');
        //     if(mapContainer && !state.mapClass.includes("mapOpenStyle"))
        //     {
        //         //mapContainer.classList.add("mapOpenStyle");
        //     }
        //     let mapContainer2 = document.getElementsByClassName("map-wrapper");
        //     if(mapContainer2){
        //         mapContainer2[0].classList.add("map-wrapper-width");
        //     }
        //     else{
        //         mapContainer2[0].classList.remove("map-wrapper-width");
        //     }
        // }
        

    };


    const [isPegmanActive, setIsPegmanActive] = useState(false);

    useEffect(() => {
    if (!mapRef.current) return;

    const streetView = mapRef.current.getStreetView();

    const handleVisibilityChange = () => {
        setIsPegmanActive(streetView.getVisible());
    };

    // Attach listener
    const listener = streetView.addListener('visible_changed', handleVisibilityChange);

    // Initial state
    setIsPegmanActive(streetView.getVisible());

    return () => {
        // Cleanup listener
        listener.remove();
    };
    }, [mapRef.current]); // Will rerun when ref is set

    const vehImage = useRef([]);
    const vehDataRef = useRef([]);
    const getNearbyVehicles = () => {
        try{
            let vehData = vehDataRef.current;
            vehImage.current = [];
            
            if(vehData?.length >= 1)
            {
                if (vehData.length === 1) {
                    let veh_data = vehData[0];
                    const status = (veh_data.hasOwnProperty("TripRequestStatus") ? 
                        veh_data.TripRequestStatus.toUpperCase() 
                        : 
                        (veh_data.hasOwnProperty("STATE") ? veh_data.STATE.toUpperCase() : "")
                    );
                    const type = (veh_data.AssignedVehType || veh_data.VehicleMake || "").toUpperCase();
                    const isVanLike = (["VAN", "WAGON", "WHEELCHAIR"].includes(type) || type.includes("VAN"));
                    const imageMap = {
                        DISCONNECTED: CabDisconnected,
                        OCCUPIED: isVanLike ? VanOccupied : SedanOccupied,
                        PICKEDUP: isVanLike ? VanOccupied : SedanOccupied,
                        OFFLINE: CabOffline,
                        ACCEPTED: isVanLike ? VanOnline : SedanOnline,
                        ONLINE: isVanLike ? VanOnline : SedanOnline,
                        IRTPU: isVanLike ? VanOnline : SedanOnline,
                        ATLOCATION: isVanLike ? VanOnline : SedanOnline,
                        ASSIGNED: isVanLike ? VanOnline : SedanOnline,
                        NOSHOWREQ: isVanLike ? VanOnline : SedanOnline,
                    };

                    const selectedImg = (imageMap[status] || (isVanLike ? VanOnline : SedanOnline));
                    vehImage.current.push(selectedImg);
                }
                else {

                    for (let vehicle in vehData) {
                        const veh_data = vehData[vehicle];
                        const status = (veh_data.hasOwnProperty("STATE") ? veh_data.STATE.toUpperCase() : "");
                        const type = (veh_data.VehicleMake ? veh_data.VehicleMake : "").toUpperCase();
                        const isVanLike = (["VAN", "WAGON"].includes(type) || type.includes("VAN"));
                        const isLift = (["VPG", "LIFT"]).includes(type);
                        const imageMap = {
                            DISCONNECTED: CabDisconnected,
                            OCCUPIED: isVanLike ? VanOccupied : (isLift ? LiftOccupied : SedanOccupied),
                            PICKEDUP: isVanLike ? VanOccupied : (isLift ? LiftOccupied : SedanOccupied),
                            OFFLINE: CabOffline,
                            ACCEPTED: isVanLike ? VanOnline : SedanOnline,
                            ONLINE: isVanLike ? VanOnline : (isLift ? LiftOnline : SedanOnline),
                            IRTPU: isVanLike ? VanOnline : (isLift ? LiftOnline : SedanOnline),
                            ATLOCATION: isVanLike ? VanOnline : (isLift ? LiftOnline : SedanOnline)
                        };

                        const selectedImg = (imageMap[status] || (isVanLike ? VanOnline : (isLift ? LiftOnline : SedanOnline)));
                        vehImage.current.push(selectedImg);
                    }
                }
            }
        }
        catch(err){};
       
    };

    

    const CreateVehicleMarker = (map, maps, lat, lng, className = 'dispatched_Vehicle', vehicleImg, direction, vehImageIndex = 0) => {
        let marker;
        try {

            // marker = new maps.Marker({
            //     position: {
            //       lat: parseFloat(lat),
            //       lng: parseFloat(lng),
            //     },
            //     map,
            //     icon: {
            //       path: maps.SymbolPath.FORWARD_CLOSED_ARROW,
            //       scale: 4,
            //       rotation: parseFloat(direction), // you must pass this
            //       strokeColor: '#000',
            //       fillColor: '#FF0000',
            //       fillOpacity: 1,
            //     }
            //   });



            marker = new maps.Marker({
                position: {
                    lat: parseFloat(lat),
                    lng: parseFloat(lng),
                },
                Animation: maps.Animation.DROP,
                icon:new maps.MarkerImage(vehicleImg, null, null, null, new maps.Size(24, 28)),//LiftOccupied,//new maps.MarkerImage(vehImage.current[vehImageIndex], null, null, null, new maps.Size(24, 28)),
                map
            });
            marker.className = className;
        } catch (error) {
            return undefined;
        }
        return marker;
    }

    const getVehicleImage2 = (veh_data) => {
        const status = (veh_data?.TripRequestStatus ?? veh_data?.STATE ?? "").toUpperCase();
        const type = (veh_data?.AssignedVehType || veh_data?.VehicleMake || "").toUpperCase();
      
        const isVanLike = ["VAN", "WAGON", "WHEELCHAIR"].includes(type) || type.includes("VAN");
        const isLift = ["VPG", "LIFT"].includes(type);
      
        const imageMap = {
          DISCONNECTED: CabDisconnected,
          OCCUPIED: isVanLike ? VanOccupied : (isLift ? LiftOccupied : SedanOccupied),
          PICKEDUP: isVanLike ? VanOccupied : (isLift ? LiftOccupied : SedanOccupied),
          OFFLINE: CabOffline,
          ACCEPTED: isVanLike ? VanOnline : (isLift ? LiftOnline : SedanOnline),
          ONLINE: isVanLike ? VanOnline : (isLift ? LiftOnline : SedanOnline),
          IRTPU: isVanLike ? VanOnline : (isLift ? LiftOnline : SedanOnline),
          ATLOCATION: isVanLike ? VanOnline : (isLift ? LiftOnline : SedanOnline),
          ASSIGNED: isVanLike ? VanOnline : (isLift ? LiftOnline : SedanOnline),
          NOSHOWREQ: isVanLike ? VanOnline : (isLift ? LiftOnline : SedanOnline)
        };
      
        return imageMap[status] || (isVanLike ? VanOnline : (isLift ? LiftOnline : SedanOnline));
      };
      
    

    const handleTagDelete = (tagToDelete) => {
           
        if(tagToDelete != undefined && tagToDelete != null){
            setTags(prev => prev.filter(tag => tag.ConfirmationNo !== tagToDelete.ConfirmationNo));
            if (typeof deletedTagCallback === 'function') {
                deletedTagCallback(tagToDelete.ConfirmationNo);
            }
            const toRemove = tripMarkers.filter(m => m.ConfirmationNo === tagToDelete.ConfirmationNo);
            toRemove.forEach(m => m.setMap(null));

            if(tagToDelete?.ConfirmationNo != undefined){
                const toRemove = tripMarkers.filter(m => m.Route === tagToDelete.Route);
                toRemove.forEach(m => m.setMap(null));
            }

            markers.forEach(marker => {
                if (marker.isVehicleMarker && marker.ConfirmationNo == tagToDelete.ConfirmationNo) {
                    marker.setMap(null);
                }
            });
        }
      };


    const onTagClick = (tag) => {
        try {
            const toHighlight = tripMarkers.filter(
                m => m.ConfirmationNo === tag.ConfirmationNo && typeof m.getPosition === 'function'
              );
              
              if (toHighlight.length < 2 || !mapRef.current || !mapsRef.current) return;
              
              const google = mapsRef.current;
              const map = mapRef.current;
              const bounds = new google.LatLngBounds();
              
              toHighlight.forEach(marker => bounds.extend(marker.getPosition()));
              
              const currentBounds = map.getBounds();
              
              const allInside = currentBounds && toHighlight.every(marker => currentBounds.contains(marker.getPosition()));
              
              if (!allInside) {
                map.fitBounds(bounds);
              } else {
                console.log("All markers are already visible, skipping fitBounds");
              }
              
             
              const originalIcons = toHighlight.map(marker => marker.getIcon());
              
              
              toHighlight.forEach(marker => {
                marker.setIcon({
                  path: google.SymbolPath.CIRCLE,
                  scale: 15,
                  fillColor: "orange",
                  fillOpacity: 1,
                  strokeWeight: 2,
                  strokeColor: "black",
                });
              });
              
          
              const polyline = new google.Polyline({
                path: toHighlight.map(marker => marker.getPosition()),
                geodesic: true,
                strokeColor: "orange",
                strokeOpacity: 1.0,
                strokeWeight: 4,
                map: map,
              });
              
             
              setTimeout(() => {
                toHighlight.forEach((marker, idx) => {
                  marker.setIcon(originalIcons[idx]);
                });
                polyline.setMap(null);
              }, 3000);
              
        } catch (error) {
            
        }
    }

    const onVehicleItemClick= (veh) => {
        try {
            const match = vehData.find(v => String(v.VehNo) === String(veh.vehNo));
            if (match && mapRef.current) {
              const lat = parseFloat(match.LATITUDE);
              const lng = parseFloat(match.LONGITUDE);
              if (!isNaN(lat) && !isNaN(lng)) {
                const position = new mapsRef.current.LatLng(lat, lng);
                mapRef.current.panTo(position);
                //mapRef.current.setZoom(16); // optional zoom
                const marker = markers.find(m =>
                    String(m.VehNo) === String(veh.vehNo)
                  );
          
                  if (marker) {
                    marker.setAnimation(mapsRef.current.Animation.BOUNCE);
                    setTimeout(() => {
                      marker.setAnimation(null);
                    }, 2000);
                  }
              }
            }
        } catch (error) {
            
        }
    }

    const onVehicleZoomClick = (veh) => {
        try {
            const match = vehData.find(v => String(v.VehNo) === String(veh.vehNo));
            if (match && mapRef.current && mapsRef.current) {
            const lat = parseFloat(match.LATITUDE);
            const lng = parseFloat(match.LONGITUDE);

            if (!isNaN(lat) && !isNaN(lng)) {
                const position = new mapsRef.current.LatLng(lat, lng);

                mapRef.current.panTo(position);
                if(!isZoomLocked){
                    mapRef.current.setZoom(16);
                }

                const marker = markers.find(m =>
                String(m.VehNo) === String(veh.vehNo)
                );

                if (marker) {
                    marker.setAnimation(mapsRef.current.Animation.BOUNCE);

                    setTimeout(() => {
                        marker.setAnimation(null);
                    }, 2000);
                }
            }
            }
        } catch (error) {
            console.error("Error in onVehicleZoomClick:", error);
    }
    };

    useEffect(() => {
        if(markers != undefined && markers?.length > 0){
            markers.forEach(m => {
                m.setAnimation(mapsRef.current.Animation.BOUNCE);
              });
              
              setTimeout(() => {
                markers.forEach(m => {
                  m.setAnimation(null);
                });
              }, 2000);
        }
    }, [showAllVehiclesOnMap])

    useEffect(() => {
        selectedRowTripType.current = TripType;
    }, [TripType])

    useEffect(() => {
        //alert("calledss");
        setVehicleBounds([]);
        setTripBounds([]);
        setRoutedTripBounds([]);
        if(markers?.length > 0){
            markers.forEach(marker => {
                try {
                    marker.setMap(null);
                } catch (error) {}
            });
        }
        vehicleMarkerMapRef.current = {};
        ResetMap();
    }, [clearMapObjects])


    function stopAnimation (marker)
    {
        setTimeout(() => {
            marker.setAnimation(null);
        }, 3000);
    }

    const handleDeleteAllTags = () => {
        if (!tags || tags.length === 0) return;
        setTags([]);
      
        if (typeof deletedTagCallback === 'function') {
          tags.forEach(tag => deletedTagCallback(tag.ConfirmationNo));
        }
      
        tags.forEach(tag => {
          const toRemoveByConfNo = tripMarkers.filter(m => m.ConfirmationNo === tag.ConfirmationNo);
          toRemoveByConfNo.forEach(m => m.setMap(null));
      
          if (tag.Route !== undefined) {
            const toRemoveByRoute = tripMarkers.filter(m => m.Route === tag.Route);
            toRemoveByRoute.forEach(m => m.setMap(null));
          }
      
          markers.forEach(marker => {
            if (marker.isVehicleMarker && marker.ConfirmationNo === tag.ConfirmationNo) {
              marker.setMap(null);
            }
          });
        });
      };


      const [resetKey, setResetKey] = React.useState(0);
      const clearVehData = () => {
        setResetKey(prev => prev + 1);
        setDispatchVehInfo([]);
        CloseVehCount.current = 0;
      };

      const UnmountDispatchActionComponent = () => {
        try{
            setinvokeDispatchComponent(false);
            if(typeof props.GridRefresh === 'function'){
                props.GridRefresh();
            }

            //instead of below hide the vehicle dispatching componenet
            // if(document.getElementById(state.GridName+"_vehMapDiv")){
            //     document.getElementById(state.GridName+"_vehMapDiv").style.display = 'none';
            // }
        } catch(err){console.log(err);}
    }


    function animateMarker2(fromLatLng, toLatLng, marker, steps = 20, delay = 50) {
        let i = 0;
    
        const deltaLat = (toLatLng.lat() - fromLatLng.lat()) / steps;
        const deltaLng = (toLatLng.lng() - fromLatLng.lng()) / steps;
    
        const interval = setInterval(() => {
            i++;
            const lat = fromLatLng.lat() + deltaLat * i;
            const lng = fromLatLng.lng() + deltaLng * i;
            marker.setPosition(new mapsRef.current.LatLng(lat, lng));
    
            if (i >= steps) clearInterval(interval);
        }, delay);
    }

    function animateMarker3(fromLatLng, toLatLng, marker, vehicleId, mapInstance, steps = 30, delay = 50) {
        let i = 0;

        const zoom = mapInstance.getZoom();
        let adjustedRadius = 50;

        if (zoom < 16) adjustedRadius = 100;
        if (zoom < 14) adjustedRadius = 200;
        if (zoom < 12) adjustedRadius = 400;
    
        const deltaLat = (toLatLng.lat() - fromLatLng.lat()) / steps;
        const deltaLng = (toLatLng.lng() - fromLatLng.lng()) / steps;
    
        // Add glowing orange circle
        const circle = new mapsRef.current.Circle({
            strokeColor: "#FFA500",
            strokeOpacity: 0.9,
            strokeWeight: 2,
            fillColor: "#FFA500",
            fillOpacity: 0.2,
            map: mapInstance,
            center: fromLatLng,
            radius: adjustedRadius,
            zIndex: 100,
        });

     
        const interval = setInterval(() => {
            i++;
            const lat = fromLatLng.lat() + deltaLat * i;
            const lng = fromLatLng.lng() + deltaLng * i;
            const currentPos = new mapsRef.current.LatLng(lat, lng);
    
            marker.setPosition(currentPos);
            circle.setCenter(currentPos);
    
            if (i >= steps) {
                clearInterval(interval);
                // Remove the circle after animation
                setTimeout(() => {
                    circle.setMap(null);
                }, 500); // show briefly after animation ends
            }
        }, delay);
    }
    
    function animateMarker(fromLatLng, toLatLng, marker, vehicleId, mapInstance, steps = 30, delay = 50) {
        let i = 0;
    
        const deltaLat = (toLatLng.lat() - fromLatLng.lat()) / steps;
        const deltaLng = (toLatLng.lng() - fromLatLng.lng()) / steps;
    
        // Create InfoWindow with "!"
        const infoWindow = new mapsRef.current.InfoWindow({
            // content: `<div style="
            // width: 20px;
            // height: 20px;
            
            // background-color: rgba(0, 0, 0, 0.9);
            // color: black;
            // font-size: 18px;
            // font-weight: bold;
            // display: flex;
            // align-items: center;
            // justify-content: center;
            // border: 2px solid #FFA500;
            // box-shadow: 0 0 8px rgba(255,165,0, 0.7);
            // ">🔶</div>`,
            // position: fromLatLng,
            // disableAutoPan: true,
            content: `
        <div style="
        position: relative;
        width: 20px;
        height: 20px;
        ">
        <div style="
            position: absolute;
            width: 10px;
            height: 10px;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background-color: black;
            border-radius: 50%;
            z-index: 2;
           // box-shadow: 0 0 4px rgba(255,165,0,0.8);
        "></div>

        <span class="ripple"></span>
        <span class="ripple delay1"></span>
        <span class="ripple delay2"></span>

        <style>
            .ripple {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: rgba(0, 0, 0, 0.4);
            transform: translate(-50%, -50%);
            animation: ripple-effect 2s infinite;
            z-index: 1;
            }

            .ripple.delay1 {
            animation-delay: 0.4s;
            }

            .ripple.delay2 {
            animation-delay: 0.8s;
            }

            @keyframes ripple-effect {
            0% {
                transform: translate(-50%, -50%) scale(1);
                opacity: 0.6;
            }
            100% {
                transform: translate(-50%, -50%) scale(3.5);
                opacity: 0;
            }
            }
        </style>
        </div>
    `,
    position: fromLatLng,
    disableAutoPan: true,
        });
    
        //infoWindow.open(mapInstance, marker);  // Show the "!" above the marker
    
        const interval = setInterval(() => {
            i++;
            const lat = fromLatLng.lat() + deltaLat * i;
            const lng = fromLatLng.lng() + deltaLng * i;
            const currentPos = new mapsRef.current.LatLng(lat, lng);
    
            marker.setPosition(currentPos);
            //infoWindow.setPosition(currentPos);  // Keep it above the moving marker
    
            if (i >= steps) {
                clearInterval(interval);
                setTimeout(() => {
                    //infoWindow.close();  // Remove the tooltip after movement ends
                }, 5000); // Keep visible for 0.5 seconds after movement
            }
        }, delay);
    }
    
    

    function createRotatedIcon(imageUrl, direction, size = 24) {
        const canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext('2d');

        const image = new Image();
        image.src = imageUrl;

        return new Promise((resolve) => {
            image.onload = () => {
            ctx.clearRect(0, 0, size, size);
            ctx.save();
            ctx.translate(size / 2, size / 2);
            ctx.rotate(direction * Math.PI / 180);
            ctx.drawImage(image, -size / 2, -size / 2, size, size);
            ctx.restore();
            resolve(canvas.toDataURL());
            };
        });
    }



    return (
        <div className='google-map-wrapper' style={{height: "100%"}}>
            <Col xs={12} id={options.GridName + '_mapContainer'} style={{ height: "100%", padding: 0 }}>
                {isMapLoading && (
                <div className="map-loader-overlay">
                    <div className="map-loader-content">
                    <div className="map-icon">
                    <Icon 
                        icon={mapIcon} 
                        width="60" 
                        height="60" 
                        style={{color: 'white'}}
                    />
                    </div>
                    <div style={{fontSize: "16px", color: "white"}}>Please wait, map is loading...</div>
                    </div>
                </div>
                )}
                <GoogleMapReact
                    bootstrapURLKeys={{ key: 'AIzaSyCUZiQELkgLvz9RFYDCl4Lsetn3H54jaXI' }}
                    defaultCenter={center}
                    defaultZoom={currentZoom}
                    yesIWantToUseGoogleMapApiInternals
                    onGoogleApiLoaded={handleApiLoaded}
                    options={createMapOptions}
                />
                {showMapOverlay && (
                    <div className='MapOverlayText'>
                        <MapOverlay label={"Showing Traffic Layer...."}></MapOverlay>
                    </div>
                )}
                
                {/* {showVehicleDispatch && (
                <div className="vehicle-table-overlay">
                    {!isCollapsedVehicleDispatch && 
                    (<VehicleDispatching
                            vehInfoArr={dispatchVehInfo}
                            CloseVehCount={CloseVehCount.current}
                            vehData={vehData}
                            onDispatchClick={({ vehicleID, driverID, vehNo }) => {
                                //setDispatchVehicleID(vehicleID);
                                //setDispatchDriverID(driverID);
                                //setinvokeDispatchComponent(true);
                            }}
                            onVehicleItemClick={onVehicleItemClick}
                            onVehicleZoomClick={onVehicleZoomClick}
                        />
                    )}
                </div>)}
                {showTripList && (
                    <Tags tagsList={tags} onTagDelete={handleTagDelete}
                        onTagClick={onTagClick}>
                    </Tags>
                )} */}

                {showRouteInfoSection && (
                    <div className="routeSummaryInfo">
                        <MapInfoSummary
                            stops = {effectiveTripData}
                            state={options}
                            clusterTableData={clusterTblStateBeforeCompute}
                        ></MapInfoSummary>
                    </div>
                )}

                {showVehicleDispatch && (
                <div className="vehicle-table-overlay"   
                    style={{
                      marginTop: isPegmanActive ? '10%' : '0px'}}
                  >
                    <VehicleDispatching
                    dispatchingVehicleNo = {dispatchingVehicleNo}
                    key={resetKey}
                    vehInfoArr={dispatchVehInfo}
                    CloseVehCount={CloseVehCount.current}
                    vehData={vehData}
                    onDispatchClick={async ({ vehicleID, driverID, vehNo }) => {
                       // alert("called");
                        setDispatchingVehicleNo(vehNo);
                        setDispatchVehicleID(vehicleID);
                        setDispatchDriverID(driverID);
                        setinvokeDispatchComponent(true);
                        // <DispatchAction GridRowData={GridRowData} selectedDriver={dispatchDriverID} selectedVehicle={dispatchVehicleID} 
                        //     DispatchVehicleData={DispatchVehicleData} DispatchDriverData={DispatchDriverData} chkVehicleRequiredRef={false}
                        //     invokeDispatchComponent={invokeDispatchComponent} setinvokeDispatchComponent={UnmountDispatchActionComponent}/>
                    }}
                    onVehicleItemClick={onVehicleItemClick}
                    onVehicleZoomClick={onVehicleZoomClick}
                    />
                    {invokeDispatchComponent && (
                        <DispatchAction 
                            GridRowData={GridRowData}
                            selectedDriver={dispatchDriverID}
                            selectedVehicle={dispatchVehicleID} 
                            DispatchVehicleData={DispatchVehicleData}
                            DispatchDriverData={DispatchDriverData}
                            chkVehicleRequiredRef={false}
                            invokeDispatchComponent={invokeDispatchComponent} 
                            setinvokeDispatchComponent={UnmountDispatchActionComponent}
                            onComplete={() => {
                                setDispatchingVehicleNo(null); // back to idle state
                              }}
                        />
                    )}
                </div>
                )}

                {showTripList && (
                <div
                    className="tripList-overlay"
                    style={{
                    top: showVehicleDispatch ? '36%' : '2px', // push it below if other is shown
                    }}
                    >
                    <Tags
                    tagsList={tags}
                    onTagDelete={handleTagDelete}
                    onTagClick={onTagClick}
                    />
                </div>
                )}


                {/* { <StatusPanel status={props.status} tripDetails={props.tripDetails} /> } */}
                {showMiniMap && <MiniMap vehiclePosition={vehiclePosition} />}

               
            </Col>
        </div>
    );
};

export default MapContainer;
